import { Container } from "@material-ui/core";
import React from "react";
import { Col, Row } from "react-bootstrap";
import challangeImg from "../../images/Agri-Investor_Challenges_-_GBR_Care_14-03-2024-removebg-preview.png";

import Monetize from "../../images/Loan Recovery Hurdles.svg";
import Order from "../../images/CSR Delivery.svg";

const InvestorChallenges = () => {
    const challanges =[{
        title:"Safe Loan",
        description:"Securing loans safely presents a challenge for investors in loan recovery, as they must navigate between risk mitigation and maintaining borrower relationships while striving to minimize financial losses and maximize recovery efforts. ",
        image:Monetize
      },
      {
        title:"CSR Delivery",
        description:"Establishing a reliable distribution channel for CSR is a challenge for investors, as it requires ensuring transparency, accountability, and alignment with stakeholders' expectations and values while maximizing impact and mitigating risks.",
        // description:"Agri-investors benefit from tangible assets like farm land and assets, which offer stability, act as valuable collateral, and reduce risks tied to market changes, ensuring a robust and enduring foundation for agricultural investments.",
        image:Order
      },
    //   {
    //     title:"Market Access",
    //     description:"Farmers face the challenge of limited market access, hindering their ability to reach a broader audience and maximize the potential for their agricultural products.",
    //     image:Ecosystem
    //   },
    
      // {
      //   title:"Brand ",
      //   description:"Branding empowers agri-producers to establish unique identities for their products, enabling differentiation and market recognition. ",
      //   image:Brand
      // }
    //  {
    //     title:"Easy Technology adoption ",
    //     description:"Affordable and user-friendly integrated agricultural technologies, enhancing productivity and efficiency on farms, are increasingly sought after by agri-producers.",
    //     image:Technology
    //   }
    ]
    return(
        <Container className="challenge-container subSectionWrapper">
        <h2 className="container-title mb-md-5 text-center">
        Agency challenges
        </h2>
  
        <Row className="align-items-center">
          <Col md={4}>
            <img src={challangeImg} alt="challange Image" className="mb-md-0 mb-4" />
          </Col>
  
          <Col md={8}>
           
  
            <Row className="challangesRow justify-content-between ">
              {challanges.map((e,index)=>{
                return <Col md={6} sm={6} xs={10} className="d-flex" key={index}>
                <div className="challangeCards  mb-md-4 ">
                  <img src={e.image} alt="Challange Icon" className="mb-3" />
                  <h6 className="mb-2">{e.title}</h6>
                  <p className="mb-0">
                   {e.description}
                  </p>
                </div>
              </Col>
             
              })}          
            </Row>
     
          </Col>
        </Row>
      </Container>
    )
};

export default InvestorChallenges
